export const DepartmentPermissionModel = {
  user_id: 0,
  user: { name: '' },
  department_id: 0,
  department: { name: '' },
  type: '',
  selectedDepartment: []
};

// Department Type
export const DEPARTMENT_TYPE_VIEW_IR = 1;
export const DEPARTMENT_TYPE_ADD_IR = 2;
export const DEPARTMENT_TYPE_APPROVE_IR = 3;
export const DEPARTMENT_TYPE_VIEW_SALE_ORDER = 4;
export const DEPARTMENT_TYPE_ADD_SALE_ORDER = 5;
export const DEPARTMENT_TYPE_APPROVE_SALE_ORDER = 6;

export const DEPARTMENT_TYPE_NAME = {
  1: "View IR",
  2: "Add IR",
  3: "Approve IR",
  4: "View Sale Order",
  5: "Add Sale Order",
  6: "Approve Sale Order",

};

export const DEPARTMENT_TYPE_DROPDOWN_OPTIONS = [
  {value: DEPARTMENT_TYPE_VIEW_IR,label: DEPARTMENT_TYPE_NAME[DEPARTMENT_TYPE_VIEW_IR]},
  {value: DEPARTMENT_TYPE_ADD_IR,label: DEPARTMENT_TYPE_NAME[DEPARTMENT_TYPE_ADD_IR]},
  {value: DEPARTMENT_TYPE_APPROVE_IR,label: DEPARTMENT_TYPE_NAME[DEPARTMENT_TYPE_APPROVE_IR]},
  {value: DEPARTMENT_TYPE_VIEW_SALE_ORDER,label: DEPARTMENT_TYPE_NAME[DEPARTMENT_TYPE_VIEW_SALE_ORDER]},
  {value: DEPARTMENT_TYPE_ADD_SALE_ORDER,label: DEPARTMENT_TYPE_NAME[DEPARTMENT_TYPE_ADD_SALE_ORDER]},
  {value: DEPARTMENT_TYPE_APPROVE_SALE_ORDER,label: DEPARTMENT_TYPE_NAME[DEPARTMENT_TYPE_APPROVE_SALE_ORDER]},


];